import script from "./CollectionFilterDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionFilterDropdown.vue?vue&type=script&setup=true&lang=js"

import "./CollectionFilterDropdown.vue?vue&type=style&index=0&id=99b7543c&lang=scss"

const __exports__ = script;

export default __exports__